import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import MacueServices from './macue_services';

export const CreateMacue = createAsyncThunk(
  'macue/create_macue',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await MacueServices.CreateMacue(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const GetAllMacue = createAsyncThunk(
  'macue/get_all_macue',
  async (payload, thunkAPI) => {
    try {
      let response = await MacueServices.getAllMacue(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetAllMajorMacue = createAsyncThunk(
  'macue/get_all_major_macue',
  async (payload, thunkAPI) => {
    try {
      let response = await MacueServices.getAllMajorMacue();

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const DeleteMacue = createAsyncThunk(
  'macue/deleteMacue',
  async (payload, thunkAPI) => {
    try {
      let response = await MacueServices.DeleteMacue(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetSingleMacueDetails = createAsyncThunk(
  'macue/get_single_macue',
  async (payload, thunkAPI) => {
    try {
      let response = await MacueServices.getSingleMacueDetails(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const EditMacueDetail = createAsyncThunk(
  'macue/edit_Macue',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await MacueServices.EditMacue(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const SearchForMacuesByName = createAsyncThunk(
  'macue/searchForMacuesByName',
  async (payload, thunkAPI) => {
    try {
      const delivered = await MacueServices.SearchForMacueByName(payload);

      return delivered;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
